<template>
  <div id="review-list-container">

    <!-- header -->
    <div
      v-if="0 < parseInt(totalCancellationReviews, 10)"
      id="review-list"
      class="pt-14"
    >

      <!-- header:title -->
      <h2 class="text-fontcolor-dark text-2xl md:text-4xl font-bold mb-1 md:mb-2 text-center md:text-left">
        {{ $t('messages_nl.cancellation.view.cancellationReview.list.title') }}
      </h2>

      <!-- header:subtitle -->
      <p class="text-lg md:text-xl text-center md:text-left">
        {{ $tc('messages_nl.cancellation.view.cancellationReview.list.subtitle', totalCancellationReviews, { companyName }) }}
      </p>

    </div>

    <!-- reviews during loading -->
    <ul
      v-if="cancellationReviewsLoading"
      class="grid grid-cols-1 gap-4 py-8"
    >
      <li
        v-for="index in 12"
        :key="index"
        class="col-span-1"
      >
        <adivare-box-loader
          class="h-60"
          show-bars-loader
          show-border-loader
          padding="md"
          shadow="againstBlueBackground"
        />
      </li>
    </ul>

    <!-- reviews after loading -->
    <template v-else-if="0 < parseInt(totalCancellationReviews, 10)">
      <!-- list -->
      <ul class="grid grid-cols-1 gap-4 py-8">
        <li v-for="(cancellationReview, index) in cancellationReviews"
          :key="cancellationReview.id"
          :class="['col-span-1', cancellationReview.isTopReview && index === 0 ? ' mt-10 mb-2' : '']"
        >
          <adivare-cancellation-review
            :cancellationReview="cancellationReview"
            :companyName="companyName"
            :index="index"
          />
        </li>
      </ul>
    </template>

    <!-- pagination -->
    <adivare-pagination
      v-if="!cancellationReviewsLoading && 12 < totalCancellationReviews"
      :current-page-number=currentPage
      :total-results="parseInt(totalCancellationReviews, 10)"
      :results-per-page=12
      watch-prop="cancellationReviews"
      class="flex justify-center my-0 md:my-6 pb-4"
      shadow-against-blue-background
      @page-change="updatePage"
      show-pages
      show-next-previous-button
      show-first-last-button
      show-first-last-numbers
      enable-scroll-to-top
      scroll-to-id="review-list"
    />
  </div>
</template>

<script>
import AdivarePagination from '../../../components/pagination';
import AdivareCancellationReview from "./cancellation-review";
import AdivareBoxLoader from "/assets/vue/components/box-loader";
import AdivareSweetAlertModal from '../../../components/sweet-alert-modal.vue';
import AdivareSwiperPrimary from '/assets/vue/components/swiper/swiper-primary.vue';
import { mapGetters } from 'vuex';

export default {
  name: "adivare-cancellation-review-list",
  components: {
    AdivarePagination,
    AdivareCancellationReview,
    AdivareBoxLoader,
    AdivareSwiperPrimary,
    AdivareSweetAlertModal,
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      settings: {
        limit: 12, // @see CancellationReview::CANCELLATION_REVIEWS_PER_PAGE
      },
    }
  },
  computed: {
    ...mapGetters([
      'companyName',
      'cancellationReviews',
      'totalCancellationReviews',
      'cancellationReviewsLoading',
    ]),
    offset() {
      return (this.settings.limit * (this.currentPage - 1));
    },
  },
  beforeMount() {
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/searchParams#examples
    const currentPage = (new URL(document.location)).searchParams.get('pagina');
    if (null !== currentPage) {
      this.currentPage = Number(currentPage);
    }
    this.loadCancellationReviews(false);
  },
  methods: {
    loadCancellationReviews(updateLocation) {
      this.loading = true;
      this.$store.dispatch('loadCancellationReviews', { limit: this.settings.limit, offset: this.offset }).then(() => {
        this.loading = false;
      });

      // Only add query param when we request more pages.
      if (updateLocation) {
        if (1 === this.currentPage) {
          window.history.replaceState('', '', window.location.pathname);
        } else {
          window.history.pushState('', '', `?pagina=${this.currentPage}`);
        }
      }
    },
    updatePage(event) {
      this.currentPage = event.page;
      this.loadCancellationReviews(true);
    },
  },
}
</script>
